import { AxiosRequestConfig } from "axios"
import { Inject } from "inversify-props"
import type { EmbalagemServiceAdapter } from "./adapter/EmbalagemServiceAdapter"

export class FindEmbalagemUseCase {
	@Inject('EmbalagemServiceAdapter')
	private embalagemService!: EmbalagemServiceAdapter

	listarPorLoja = async (lojaId: string, params: any, config?: AxiosRequestConfig) => await this.embalagemService.listarPorLoja(lojaId, params, config)
}